module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('section', {
    staticClass: "joint-assessment"
  }, [_c('img', {
    staticClass: "pointer",
    attrs: {
      "src": require("../assets/images/www-race-banner.png"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/race')
      }
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('section', {
    staticClass: "cpzx"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "products-description"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.productsType == 1),
      expression: "productsType==1"
    }],
    staticClass: "description-box"
  }, [_vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.productsType == 2),
      expression: "productsType==2"
    }],
    staticClass: "description-box"
  }, [_vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.productsType == 3),
      expression: "productsType==3"
    }],
    staticClass: "description-box"
  }, [_vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.productsType == 4),
      expression: "productsType==4"
    }],
    staticClass: "description-box"
  }, [_vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14)])]), _vm._v(" "), _c('div', {
    staticClass: "products-img"
  }, [_c('div', {
    staticClass: "img-big"
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.productsType == 1),
      expression: "productsType==1"
    }],
    attrs: {
      "src": require("../assets/img/img-products-1.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.productsType == 2),
      expression: "productsType==2"
    }],
    attrs: {
      "src": require("../assets/img/img-products-2.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.productsType == 3),
      expression: "productsType==3"
    }],
    attrs: {
      "src": require("../assets/img/img-products-3.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.productsType == 4),
      expression: "productsType==4"
    }],
    attrs: {
      "src": require("../assets/img/img-products-4.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "arrow-left",
    on: {
      "click": _vm.productsLeft
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/img-arrow-left.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "arrow-right",
    on: {
      "click": _vm.productsRight
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/img-arrow-right.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "img-min"
  }, [_c('img', {
    class: {
      'active': _vm.productsType === 1
    },
    attrs: {
      "src": require("../assets/img/img-products-1.png"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.productsType = 1
      }
    }
  }), _vm._v(" "), _c('img', {
    class: {
      'active': _vm.productsType === 2
    },
    attrs: {
      "src": require("../assets/img/img-products-2.png"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.productsType = 2
      }
    }
  }), _vm._v(" "), _c('img', {
    class: {
      'active': _vm.productsType === 3
    },
    attrs: {
      "src": require("../assets/img/img-products-3.png"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.productsType = 3
      }
    }
  }), _vm._v(" "), _c('img', {
    class: {
      'active': _vm.productsType === 4
    },
    attrs: {
      "src": require("../assets/img/img-products-4.png"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.productsType = 4
      }
    }
  })])])])]), _vm._v(" "), _vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _c('section', {
    staticClass: "login-wrap"
  }, [_c('Login')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "zxhx"
  }, [_c('div', {
    staticClass: "title-box"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("进一步了解知心慧学")]), _vm._v(" "), _c('i', {
    staticClass: "border-bottom"
  })]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "top clearfix"
  }, [_c('div', {
    staticClass: "images fl"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/img-ywfw.png"),
      "alt": "业务范围"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text fr"
  }, [_c('h3', {
    staticClass: "ywfw"
  }, [_vm._v("我们的业务范围")]), _vm._v(" "), _c('p', [_vm._v("\n              知心慧学一直致力于互联网教育领域的产品研发，着力于用大数据及人工智能等信息技术提升教育的质量与效率。与基础教育学校一道，努力探索让信息技术深度融入于学校教学，在互联网+的大时代背景下推动学校的转型与发展。")])])]), _vm._v(" "), _c('div', {
    staticClass: "bottom clearfix"
  }, [_c('div', {
    staticClass: "text fl"
  }, [_c('h3', {
    staticClass: "sjwj"
  }, [_vm._v("强大的数据挖掘能力")]), _vm._v(" "), _c('p', [_vm._v("\n              知心慧学强大的数据挖掘与分析能力是实现个性化、精准化教学的基础与保障。我们将每个教师、每个学生、每场考试的过程数据收集记录下来，将每次鼠标点击、每道试题的分数转化为清晰的个人能力模型和精准的学情分析报告。")])]), _vm._v(" "), _c('div', {
    staticClass: "images fr"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/img-sjwj.png"),
      "alt": "数据挖掘"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "jjfa"
  }, [_c('div', {
    staticClass: "title-box"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("知心慧学基于测评大数据的解决方案")]), _vm._v(" "), _c('i', {
    staticClass: "border-bottom"
  })]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "card gstg"
  }, [_c('div', {
    staticClass: "card-in"
  }, [_c('div', {
    staticClass: "card-front"
  }, [_c('div', {
    staticClass: "card-title"
  }, [_c('h4', {
    staticClass: "text"
  }, [_vm._v("公司提供")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-back"
  }, [_c('p', [_c('em', {
    staticClass: "sign"
  }, [_vm._v("·")]), _vm._v("周期作业、月度测评、学业评估的分析报告及错题本、个性化学习宝。基于大数据分析的网络课（每学期平时5次双师课，师生共同学习）\n                基于大数据分析的典型课（对学生 假期15次）\n                基于大数据分析个性化典型问题的微课、闯关训练")]), _vm._v(" "), _c('p', [_c('em', {
    staticClass: "sign"
  }, [_vm._v("·")]), _vm._v("专职学管，负责数据采集及打印试卷、错题本、个性化学习宝等服务")]), _vm._v(" "), _c('p', [_c('em', {
    staticClass: "sign"
  }, [_vm._v("·")]), _vm._v("办公电脑、大型扫描仪、打印机")]), _vm._v(" "), _c('p', [_c('em', {
    staticClass: "sign"
  }, [_vm._v("·")]), _vm._v("知心慧学大数据教育系统")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card falj"
  }, [_c('div', {
    staticClass: "card-in"
  }, [_c('div', {
    staticClass: "card-front"
  }, [_c('div', {
    staticClass: "card-title"
  }, [_c('h4', {
    staticClass: "text"
  }, [_vm._v("方案逻辑")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-back"
  }, [_c('p', [_c('em', {
    staticClass: "sign"
  }, [_vm._v("·")]), _vm._v("测试数据采集")]), _vm._v(" "), _c('p', [_c('em', {
    staticClass: "sign"
  }, [_vm._v("·")]), _vm._v("测试数据分析")]), _vm._v(" "), _c('p', [_c('em', {
    staticClass: "sign"
  }, [_vm._v("·")]), _vm._v("线下个性化训练方案")]), _vm._v(" "), _c('p', [_c('em', {
    staticClass: "sign"
  }, [_vm._v("·")]), _vm._v("线上网络方案")]), _vm._v(" "), _c('p', [_c('em', {
    staticClass: "sign"
  }, [_vm._v("·")]), _vm._v("线上典型考点微课学习及闯关训练")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card xxtg"
  }, [_c('div', {
    staticClass: "card-in"
  }, [_c('div', {
    staticClass: "card-front"
  }, [_c('div', {
    staticClass: "card-title"
  }, [_c('h4', {
    staticClass: "text"
  }, [_vm._v("学校提供")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-back"
  }, [_c('p', [_c('em', {
    staticClass: "sign"
  }, [_vm._v("·")]), _vm._v("大数据中心（学管办公室，30~60平方米，通电、通网）")]), _vm._v(" "), _c('p', [_c('em', {
    staticClass: "sign"
  }, [_vm._v("·")]), _vm._v("PAD学习教室（1~2间，每间50~60个座位，通电、通网）")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card lszsm"
  }, [_c('div', {
    staticClass: "card-in"
  }, [_c('div', {
    staticClass: "card-front"
  }, [_c('div', {
    staticClass: "card-title"
  }, [_c('h4', {
    staticClass: "text"
  }, [_vm._v("老师做什么")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-back"
  }, [_c('p', [_c('em', {
    staticClass: "sign"
  }, [_vm._v("·")]), _vm._v("检查学校生成错题本、个性化学习宝的情况")]), _vm._v(" "), _c('p', [_c('em', {
    staticClass: "sign"
  }, [_vm._v("·")]), _vm._v("组织学生参加网络双师课，并对学生进行指导")]), _vm._v(" "), _c('p', [_c('em', {
    staticClass: "sign"
  }, [_vm._v("·")]), _vm._v("组织学生参加PAD微课学习，并随堂指导讲解")]), _vm._v(" "), _c('p', [_c('em', {
    staticClass: "sign"
  }, [_vm._v("·")]), _vm._v("参加网络研修，学习方法、技巧，提升教学能力")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card xszsm"
  }, [_c('div', {
    staticClass: "card-in"
  }, [_c('div', {
    staticClass: "card-front"
  }, [_c('div', {
    staticClass: "card-title"
  }, [_c('h4', {
    staticClass: "text"
  }, [_vm._v("学生做什么")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-back"
  }, [_c('p', [_c('em', {
    staticClass: "sign"
  }, [_vm._v("·")]), _vm._v("看分析报告了解薄弱点")]), _vm._v(" "), _c('p', [_c('em', {
    staticClass: "sign"
  }, [_vm._v("·")]), _vm._v("完成错题本、个性化学习宝")]), _vm._v(" "), _c('p', [_c('em', {
    staticClass: "sign"
  }, [_vm._v("·")]), _vm._v("通过网络学习")]), _vm._v(" "), _c('p', [_c('em', {
    staticClass: "sign"
  }, [_vm._v("·")]), _vm._v("运用PAD学习薄弱考点微课，并完成闯关训练")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card ldzsm"
  }, [_c('div', {
    staticClass: "card-in"
  }, [_c('div', {
    staticClass: "card-front"
  }, [_c('div', {
    staticClass: "card-title"
  }, [_c('h4', {
    staticClass: "text"
  }, [_vm._v("领导做什么")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-back"
  }, [_c('p', [_c('em', {
    staticClass: "sign"
  }, [_vm._v("·")]), _vm._v("校长或年级主任主抓，制定奖惩制度")]), _vm._v(" "), _c('p', [_c('em', {
    staticClass: "sign"
  }, [_vm._v("·")]), _vm._v("制定考练计划，统一考试，统一阅卷")]), _vm._v(" "), _c('p', [_c('em', {
    staticClass: "sign"
  }, [_vm._v("·")]), _vm._v("及时反馈，及时讲评")]), _vm._v(" "), _c('p', [_c('em', {
    staticClass: "sign"
  }, [_vm._v("·")]), _vm._v("组织学生学习pad课程")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-box"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("产品中心")]), _vm._v(" "), _c('i', {
    staticClass: "border-bottom"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "name-wrap"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("个性化学习宝")]), _vm._v(" "), _c('i', {
    staticClass: "triangle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-big"
  }, [_c('p', [_vm._v("查漏补缺，举一反三，触类旁通，快速掌握")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-min"
  }, [_c('p', [_vm._v("量身定制个性化训练方案， 查缺补漏，举一反三，避免学生盲目训练，方便纠错学习。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "name-wrap"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("错题本")]), _vm._v(" "), _c('i', {
    staticClass: "triangle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-big"
  }, [_c('p', [_vm._v("每天20至30分钟提升学习效率")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-min"
  }, [_c('p', [_vm._v("明晰自身学习的缺漏与不足，瞄准目标与方向。节省抄写的时间精力，保留作答原笔迹，提高回顾学习效率。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "name-wrap"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("教学宝")]), _vm._v(" "), _c('i', {
    staticClass: "triangle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-big"
  }, [_c('p', {
    staticStyle: {
      "letter-spacing": "-2px"
    }
  }, [_vm._v("打印整合成册，让老"), _c('br'), _vm._v("师学生“教”“学”更方便”")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-min"
  }, [_c('p', [_vm._v("将答题详情、学情统计、学生成绩动态跟踪表、班级变式训练题等整理成册帮助教师科学备课、精准讲评、个性化授课。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "name-wrap"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("教研网")]), _vm._v(" "), _c('i', {
    staticClass: "triangle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-big"
  }, [_c('p', [_vm._v("同步教研资源，骨干教师在线直播")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-min"
  }, [_c('p', [_vm._v("针对教师教学当中遇到的教材分析、教学目标、教学设计、学法指导、特色创新、课时作业设计等实际问题，开展在线互动讲座，帮助教师在备课、上课和布置训练时开阔视野，点拨思维。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hzxx"
  }, [_c('div', {
    staticClass: "title-box"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("深度合作学校")]), _vm._v(" "), _c('i', {
    staticClass: "border-bottom"
  })]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/s-logo-1.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/images/s-logo-2.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/images/s-logo-3.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/images/s-logo-4.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/images/s-logo-5.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/images/s-logo-6.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/images/s-logo-7.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/images/s-logo-8.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/images/s-logo-9.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/images/s-logo-10.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/images/s-logo-11.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/images/s-logo-12.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/images/s-logo-13.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/images/s-logo-14.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/images/s-logo-15.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/images/s-logo-16.png"),
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "gstd"
  }, [_c('div', {
    staticClass: "title-box"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("我们的团队")]), _vm._v(" "), _c('i', {
    staticClass: "border-bottom"
  })]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "card-box"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/img-fwtd.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v("服务团队")])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/img-yftd.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v("研发团队")])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/img-jstd.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v("技术团队")])])]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("\n          风向标科技拥有强大的技术实力，在上海和南昌分别设立技术中心，拥有专职技术人员近百名，多人拥有海外上市技术公司的管理经验，团队服务过的在线测评、大数据分析处理的用户级别达千万。风向标技术团队始终紧跟前沿技术，技术的延伸性和先进性有机结合，形成了真正可靠稳定的技术优势，在大数据和人工智能领域都有专业建树。")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5793fa4c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 518
// module chunks = 2